<template>
  <div class="common-alert cover-layer">
    <div class="common-alert__content">
      <div class="alert-content__status">
        <img :src="require(`@/assets/status/status_${status}.png`)" />
      </div>
      <div class="alert-content__message">{{message}}</div>
      <div class="alert-content__button">
        <button @click="closeModelEvent">
          <span>{{confirmText}}</span>
          <span v-if="countdown">（{{countdown / 1000}}）</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'common-alert',
  model: {
    prop: 'modelValue',
    event: 'modelInput',
  },

  props: {
    modelValue: Boolean,
    type: {
      type: String,
      default: 'success',
      comment: '是成功还是失败的反馈',
    },
    message: {
      type: String,
      default: '您的提交已成功受理!',
      comment: '当类型为alert时显示的提示文本',
    },
    duration: {
      type: Number,
      default: 3000,
      comment: '弹窗持续时间或者多少秒后自动关闭, 单位: 毫秒',
    },
    confirmText: {
      type: String,
      default: '确认',
      comment: '确认按钮文本',
    },
  },

  data() {
    return {
      countdown: this.duration,
    }
  },

  computed: {
    status() {
      return this.types.includes(this.type) ? this.type : 'success'
    },
  },

  methods: {
    closeModelEvent() {
      this.$emit('modelInput', false)
    },
  },

  mounted() {
    let timeout = null,
      interval = null

    if (this.duration !== 0) {
      // 三秒倒计时
      interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1000
        } else {
          this.countdown = 0
        }
      }, 1000)

      // 三秒后自动触发回调
      timeout = setTimeout(() => {
        this.closeModelEvent()
        clearInterval(interval)
        clearTimeout(timeout)
      }, this.duration)
    }

    // 禁止页面滚动
    document.documentElement.classList.add('lock')

    // 组件销毁的时候清除定时器
    this.$once('hook:beforeDestroy', () => {
      document.documentElement.classList.remove('lock')
      clearInterval(interval)
      clearTimeout(timeout)
    })
  },
}
</script>

<style lang="scss" scoped>
.common-alert {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  background: rgba($color: #000, $alpha: 0.4);
  z-index: 2500;

  &__content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    padding: 45px;
    border-radius: 10px;
    background: #fff;
    text-align: center;
    font-size: 16px;
    overflow: hidden;

    .alert-content__status {
      width: 60px;
      height: 60px;
      margin: 0 auto 15px;

      img {
        width: 100%;
      }
    }

    .alert-content__message {
      line-height: 24px;
    }

    .alert-content__button {
      margin-top: 30px;

      button {
        width: 140px;
        height: 40px;
        border: 0;
        outline: 0;
        border-radius: 4px;
        background: #f1f3f6;
        font-weight: bold;
        font-size: 15px;
        cursor: pointer;

        &:active {
          background: #e6e6e6;
        }
      }
    }
  }
}
</style>